import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import { sectionNames } from "@saleor/intl";
import { PageheaderList_pageHeaders_edges_node } from "@saleor/pageheaders/types/PageheaderList";
import { PageheaderListUrlSortField } from "@saleor/pageheaders/urls";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Container from "../../../components/Container";
import PageHeader from "../../../components/PageHeader";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SortPage,
  TabPageProps
} from "../../../types";
import PageheaderList from "../PageheaderList";
import {
  createFilterStructure,
  PageheaderFilterKeys,
  PageheaderListFilterOpts} from "./filters";

export interface PageheaderListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<PageheaderFilterKeys, PageheaderListFilterOpts>,
    SortPage<PageheaderListUrlSortField>,
    TabPageProps {
  pageheaders: PageheaderList_pageHeaders_edges_node[];
  onBack: () => void;
  toatlCount:number;
}

const PageheaderListPage: React.FC<PageheaderListPageProps> = ({
  currencySymbol,
  filterOpts,
  initialSearch,
  onAdd,
  onBack,
  onFilterChange,
  onSearchChange,
  currentTab,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  toatlCount,
  ...listProps
}) => {
  const intl = useIntl();

  const structure = createFilterStructure(intl, filterOpts);

  return (
    <Container>
      <AppHeader onBack={onBack}>
        <FormattedMessage {...sectionNames.configuration} />
      </AppHeader>
      <PageHeader title={intl.formatMessage(sectionNames.pageheaders)+"("+toatlCount+")"}>
        <Button onClick={onAdd} color="primary" variant="contained">
          <FormattedMessage
            defaultMessage="Create PageHeader"
            description="button"
          />
        </Button>
      </PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All Pageheaders",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Pageheader..."
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <PageheaderList {...listProps} />
      </Card>
    </Container>
  );
};
export default PageheaderListPage;
